import { createContext, useContext } from 'react'

import { type EmployersEmployerInvoice, type EmployersMemberInvoiceDetail } from 'utils/web_api.schemas'

type InvoiceContextType = {
  invoice: EmployersEmployerInvoice
  enrichedMemberInvoices: EmployersMemberInvoiceDetail[]
}

export const InvoiceContext = createContext<InvoiceContextType | null>(null)

export function useInvoice () {
  const context = useContext(InvoiceContext)
  if (!context) {
    throw new Error('useInvoice must be used within InvoiceProvider')
  }
  return context
}

interface InvoiceProviderProps {
  invoice: EmployersEmployerInvoice
  enrichedMemberInvoices: EmployersMemberInvoiceDetail[]
  children: React.ReactNode
}

export function InvoiceProvider ({
  invoice,
  enrichedMemberInvoices,
  children,
}: InvoiceProviderProps) {
  return (
    <InvoiceContext.Provider value={{ invoice, enrichedMemberInvoices }}>
      {children}
    </InvoiceContext.Provider>
  )
}
